import { css } from 'aphrodite/no-important';
import { Icon } from 'office-ui-fabric-react';
import React, { FC } from 'react';
import { FileUploadButton, ImageDropzone } from 'react-file-utils';
import { ChatAutoComplete, MessageInputProps, useChannelStateContext, useMessageInputContext } from 'stream-chat-react';
import { SendIcon } from 'util/icons';
import { palette } from 'util/style-helpers';
import { style } from './style';
import { UploadsPreview } from './UploadsPreview';

export const AttendeeMessageInput: FC<MessageInputProps> = (props) => {
  const styles = style();
  const messageInput = useMessageInputContext();

  const iconButtonStyles = {
    root: {
      color: palette.black,
    },
    rootHovered: {
      color: palette.black,
      background: 'transparent',
    },
  };
  const { acceptedFiles, maxNumberOfFiles, multipleUploads } = useChannelStateContext();

  return (
    <div className={css(styles.messageInputWrapper)}>
      <ImageDropzone
        accept={acceptedFiles}
        handleFiles={messageInput.uploadNewFiles as any}
        multiple={multipleUploads}
        disabled={maxNumberOfFiles !== undefined && messageInput.numberOfUploads >= maxNumberOfFiles}>
        <div className={css(styles.messageInputInput)}>
          {!messageInput.noFiles && <UploadsPreview />}
          <div className={css(styles.messageInputInputWrapper)}>
            <ChatAutoComplete placeholder='Ask us a question' />
            <button
              className={css(styles.messageInputSendButton)}
              aria-label='Send Message'
              onClick={messageInput.handleSubmit}>
              <SendIcon />
            </button>
            {!messageInput.noFiles && (
              <FileUploadButton handleFiles={messageInput.uploadNewFiles as any}>
                <Icon styles={iconButtonStyles} iconName='Zoom' ariaLabel='Attach File' />
              </FileUploadButton>
            )}
          </div>
        </div>
      </ImageDropzone>
    </div>
  );
};
